import * as Sentry from '@sentry/react';

export const captureException: typeof Sentry.captureException = (...args) => {
  return Sentry.captureException(...args);
};
